import React from "react";
import styles from "../../styles/evento-form.module.css"; // ajusta la ruta real

export function StepTransfer({ form, setField }) {
    return (
        <div className={styles.step}>
            <h3 className={styles.stepTitle}>Transfer</h3>

            <div className={styles.field}>
                <label className={styles.label}>Notas de transfer</label>
                <textarea
                    className={`${styles.textarea} ${styles.transferTextarea}`}
                    value={form.transfer || ""}
                    onChange={(e) => setField("transfer", e.target.value)}
                    placeholder="Escribe aquí la información de transfer..."
                />

                <div className={styles.hint}>
                    Campo de texto libre, sin límite práctico de caracteres.
                </div>
            </div>
        </div>
    );
}
